import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { LicenseInfo } from "@mui/x-license";
import { clearInvalidLocalStoragePrefs } from "@pepsico/pref-permissions";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { defaultPrefs } from "defs";
import { createAppRoutes } from "routes";

LicenseInfo.setLicenseKey(
  "61e6b6faf9be62d3494b41d8b2ea7ae9Tz0xMjA4NDcsRT0xNzkyNzk5OTk5MDAwLFM9cHJlbWl1bSxMTT1wZXJwZXR1YWwsUFY9aW5pdGlhbCxLVj0y",
);

const queryClient = new QueryClient();

const router = createBrowserRouter(createAppRoutes());

clearInvalidLocalStoragePrefs(defaultPrefs);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
